import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";
import { EXPERTISE } from "../data";

const EASE = [0.22, 1, 0.36, 1];

export default function Expertise() {
  const [active, setActive] = useState(0);
  const area = EXPERTISE.areas[active];

  return (
    <section id="expertise" data-testid="expertise-section" className="relative py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-[1240px] mx-auto">
        <Reveal>
          <p className="font-display text-accent text-sm mb-3">{EXPERTISE.eyebrow}</p>
          <h2 className="font-display font-semibold text-3xl md:text-[2.6rem] leading-tight tracking-tight max-w-3xl">
            {EXPERTISE.title}
          </h2>
        </Reveal>

        {/* Area toggle buttons */}
        <Reveal delay={0.05}>
          <div className="flex flex-wrap gap-3 mt-9">
            {EXPERTISE.areas.map((a, i) => (
              <button
                key={a.name}
                data-testid={`expertise-tab-${i}`}
                onClick={() => setActive(i)}
                className={`font-display font-medium text-sm md:text-[15px] rounded-full px-5 py-3 transition-all duration-300 ${
                  active === i
                    ? "bg-ink text-bg shadow-[0_10px_25px_-12px_rgba(23,23,26,0.6)]"
                    : "bg-card text-ink-soft hover:text-ink border border-ink/10"
                }`}
              >
                {a.name}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mt-6 md:mt-8">
          <AnimatePresence mode="wait">
            <motion.div
              key={`body-${active}`}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -12 }}
              transition={{ duration: 0.45, ease: EASE }}
              className="card p-8 md:p-10 h-full"
            >
              <h3 className="font-display font-semibold text-2xl md:text-3xl mb-4">{area.name}</h3>
              <p className="text-ink-soft leading-relaxed" data-testid="expertise-body">{area.body}</p>
              <div className="flex flex-wrap gap-2.5 mt-8">
                {area.skills.map((s) => (
                  <span key={s} className="tag">{s}</span>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <motion.div
              key={`stats-${active}`}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -12 }}
              transition={{ duration: 0.45, ease: EASE, delay: 0.05 }}
              className="grid grid-cols-2 gap-6 md:gap-8 h-full"
            >
              {area.stats.map((s, i) => (
                <div key={i} className="card p-7 md:p-8 flex flex-col justify-center">
                  <div className="font-display font-semibold text-4xl md:text-5xl tracking-tight">{s.value}</div>
                  <div className="text-ink-soft text-sm mt-2 leading-snug">{s.label}</div>
                </div>
              ))}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
